import { render, staticRenderFns } from "./SubelementCreate.vue?vue&type=template&id=09f86cc8"
import script from "./SubelementCreate.vue?vue&type=script&lang=ts"
export * from "./SubelementCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports